import { Component, OnInit, OnDestroy, NgZone, AfterViewInit } from '@angular/core';
import { IAgoraRTCRemoteUser, IAgoraRTCClient, ICameraVideoTrack, IMicrophoneAudioTrack, ILocalVideoTrack, AREAS } from "agora-rtc-sdk-ng";
import AgoraRTC from "agora-rtc-sdk-ng";
import { ApiService } from '../../api.service';
import { ActivatedRoute } from "@angular/router";
import { ToastrService } from 'ngx-toastr';
import { NgxFileDropEntry, FileSystemFileEntry } from 'ngx-file-drop';
import { environment } from './../../../environments/environment';
declare var $: any;
import Swal from 'sweetalert2';
import VirtualBackgroundExtension from "agora-extension-virtual-background";
import { Howl, Howler } from 'howler';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
/* import { Firestore, collection, collectionData, query, where, collectionChanges, DocumentChange, orderBy, writeBatch, doc, getDocs } from '@angular/fire/firestore'; */
import { AgoraRtmService } from '../../agora-rtm.service';

@Component({
	selector: 'app-chat',
	templateUrl: './chat.component.html',
	styleUrl: './chat.component.scss'
})
export class ChatComponent implements OnInit, OnDestroy, AfterViewInit {
	remoteCalls: any[] = [];
	localStreams: any = [];
	currentVideo: any = null;

	videoClient!: IAgoraRTCClient;
	screenClient!: IAgoraRTCClient;
	localStream!: ICameraVideoTrack;
	localAudioStream!: IMicrophoneAudioTrack;
	shareStream!: ILocalVideoTrack;

	token: any = null;
	chat_token: any = "006731e0cc2e2a04d1ab31cc97de766a6b1IABUVkGwzr5Q2fBfZhFj/32kqy3sLoMqFITSzA57OSnsGDgbtvMAAAAAEAAA2t0EIS8laQEA6AOx6yNp";
	channelName: any = "4";
	userId: number = 4;
	screenUserId!: number;
	/* otherSideUserId!: number;
	otherSideScreenUserId!: number; */
	userName: string = "";
	joinStatus = { isJoined: false };
	isMute = false;
	isVideoMute = false;
	agoraAppId = environment.agoraAppID;
	cameraVideoProfile = '480_4';
	screenVideoProfile = '480_2';
	testCompleted = false;
	unreadUsernames: any = [];
	msg = '';
	messages: any[] = [];
	peers: string[] = [];
	private subs: Subscription[] = [];
	classVar = true;
	fileUploaderLoader = false;
	public files: NgxFileDropEntry[] = [];
	errorLog: any = null;
	errorLogs = false;
	displayerror = false;
	isApptDeleted = false;
	errorMsg = "";
	videoEncoderConfig = { resolution: { width: 320, height: 240 }, frameRate: { min: 15, max: 24 }, bitrate: { min: 140, max: 200 } };
	screenVideoEncoderConfig = { resolution: { width: 320, height: 240 }, frameRate: { min: 15, max: 24 }, bitrate: { min: 140, max: 200 } };
	numbers = [
		{ num: 1, color: "#28a745" },
		{ num: 2, color: "#28a745" },
		{ num: 3, color: "#007bff" },
		{ num: 4, color: "#007bff" },
		{ num: 5, color: "#ffc107" },
		{ num: 6, color: "#ffc107" },
		{ num: 7, color: "#ff5707" },
		{ num: 8, color: "#ff5707" },
		{ num: 9, color: "#dc3545" },
		{ num: 10, color: "#dc3545" }
	];
	numberOfPidsToColor: number = 0;
	isRecording = false;
	recordedTime: any;
	blobUrl: any;
	intervalMicListen: any = null;
	playAlertRing = new Howl({
		src: ['../../../assets/files/sound1.mp3']
	});
	playAlertNotify = new Howl({
		src: ['../../../assets/files/sound2.mp3']
	});
	isTabOpen = true;
	isPopupOpen = false;
	audioDevices: any[] = [];
	videoDevices: any[] = [];
	selectedMicrophoneId: any = null;
	selectedCameraId: any = null;
	QuizeList: any[] = [];
	userAnsLoader: boolean = false;
	BasicData: any = null;
	swatQuestions: any[] = [];
	OwnerId: any = localStorage.getItem("OwnerId");
	doctor_avatar = "../../../assets/img/PSYCHOLOGIST.png";
	remoteUsers: any[] = [];
	isPanelOpen = true;
	videoHeight = 200;
	videoWidth = "100%";
	labelHeight = 22;
	mainVideoHeight: number = window.innerHeight - 130;
	extension = new VirtualBackgroundExtension();
	processor: any = null;
	virtualBackgroundEnabled: string = "";
	backgroundProp: string = "#00ff00";
	bgColors = [
		"#00008B",
		"#808080",
		"#FBFAF5",
		"#475c6c",
		"#eed7a1",
		"#f7efd2"
	];
	bgImages = [
		"../../../assets/img/bg1.jpeg",
		"../../../assets/img/bg2.jpg",
		"../../../assets/img/bg3.jpg",
		"../../../assets/img/bg4.jpg",
		"../../../assets/img/bg5.jpg",
		"../../../assets/img/bg6.jpg"
	];
	uId: any = null;
	followId: any = null;
	breadcrumbList: any[] = [
		{
			path: this.apiService.getHomeURL(),
			name: "Home"
		},
		{
			path: "/app/list-appointment",
			name: "Appointment List"
		}
	];
	pageLoading1 = false;
	followUpDetails: any = null;
	user: any = null;
	constructor(private agora: AgoraRtmService, private toastr: ToastrService, private apiService: ApiService, private activeRoute: ActivatedRoute) { }

	ngOnInit(): void {
		this.activeRoute.params.subscribe(routeParams => {
			/* this.uId = routeParams["caseId"];
			this.followId = routeParams["followId"];
			this.userId = parseInt(routeParams["userId"]); */
			try {
				this.uId = decodeURIComponent(this.uId);
			} catch (e) { }
			try {
				this.followId = decodeURIComponent(this.followId);
			} catch (e) { }
			this.breadcrumbList.push({ path: "/app/appt-details/no/" + this.uId + "/" + this.followId, name: "Appointment Details", queryparams: { "follow-up": this.followId } });
			this.breadcrumbList.push({ path: "/app/followup-report/" + this.uId + "/" + this.followId, name: "Video Call" });
			this.apiService.userData$.subscribe((user: any) => {
				if (user) {
					this.user = user;
					/* this.getDetails(); */
				}
			})
			this.joinChat()
		});
	}

	ngOnDestroy(): void {
		try {
			this.subs.forEach(s => s.unsubscribe());
			this.agora.leaveChannel();
			this.agora.logout();
		} catch (error) { }
	}

	ngAfterViewInit(): void {
	}

	getDetails() {
		this.pageLoading1 = true;
		this.apiService.getFollowupDetails(this.followId).subscribe({
			next: (data: any) => {
				this.pageLoading1 = false;
				this.followUpDetails = data.data;
				this.channelName = this.followUpDetails.case_id.id.toString();
				/* this.userId = this.user.id; */
				this.userName = `${this.user.first_name} ${this.user.last_name}`;
				this.setupVars();
			}, error: (error) => {
				this.pageLoading1 = false;
				this.followUpDetails = null;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	setupVars() {
		this.apiService.getAgoraToken(this.userId, this.channelName).subscribe({
			next: (data: any) => {
				this.chat_token = data["rtm_token"];
				this.joinChat();
			}, error: (error) => {
				this.toastr.error("Unable to initiate call.", 'Error', {
					tapToDismiss: true,
					closeButton: true,
					timeOut: 3000
				});
			}
		});
	}

	openFileMang() {
		$("#chatFileModal").modal("show");
	}

	sendMsg(photoURL: any, dataText: any) {
		if (!dataText || !dataText.trim()) {
			return;
		}
		
		this.agora.sendChannelMessage(dataText.trim()).then(
			(val: any) => {
				console.log(val);
				this.msg = '';
			}, (error) => {
				console.log(error);
			}
		);
	}

	async joinChat() {
		await this.agora.init(environment.agoraAppID);
		await this.agora.login(this.userId.toString(), this.chat_token);
		await this.agora.joinChannel(this.channelName);
		this.subs.push(this.agora.messages$.subscribe(m => this.messages = m));
		this.subs.push(this.agora.peers$.subscribe(p => this.peers = p));
	}

	clipText(text: String, length: number) {
		return text.slice(0, length);
	}

	public caseFilesUpload(files: NgxFileDropEntry[]) {
		this.files = files;
		/* for (const droppedFile of files) {
			if (droppedFile.fileEntry.isFile) {
				const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
				fileEntry.file((file: File) => {
					this.fileUploaderLoader = true;
					let fileName = file.name;
					this.apiService.fileUpload(fileName, environment.CHAT_FILE_UPLOAD_DESTINATION).subscribe({
						next: (data: any) => {
							this.fileUploaderLoader = false;
							this.fileUploaderLoader = true;
							this.apiService.uploadFileToS3(file, data[0].presigned_url).subscribe({
								next: res => {
									this.fileUploaderLoader = false;
									const chatFileData = {
										"id": this.channelNameEncoded,
										"filename": data[0].file_name,
										"file": data[0].file_url
									}
									this.fileUploaderLoader = true;
									this.apiService.chatFileUpload(chatFileData).subscribe({
										next: (res1: any) => {
											this.fileUploaderLoader = false;
											this.sendMsg(data[0].file_url, data[0].orig_name);
											$("#chatFileModal").modal("hide");
										}, error: (error: any) => {
											this.fileUploaderLoader = false;
											this.toastr.error("Unable to upload.", 'Error', {
												timeOut: 3000,
												tapToDismiss: true,
												closeButton: true
											});
										}
									});
								}, error: (error) => {
									this.fileUploaderLoader = false;
									this.toastr.error("Something went wrong.", 'Error', {
										tapToDismiss: true,
										closeButton: true,
										timeOut: 3000
									});
								}
							});
						}, error: (error) => {
							this.fileUploaderLoader = false;
							this.toastr.error("Something went wrong.", 'Error', {
								tapToDismiss: true,
								closeButton: true,
								timeOut: 3000
							});
						}
					});
				});
			} else {
				this.errorLog = "Invalid File Format.";
				this.errorLogs = true;
				setTimeout(() => {
					this.errorLogs = false;
				}, 10000);
				this.toastr.error("Invalid File Format.", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		} */
	}

	validURL(str: any) {
		var pattern = new RegExp('^(https?:\\/\\/)?' +
			'((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' +
			'((\\d{1,3}\\.){3}\\d{1,3}))' +
			'(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' +
			'(\\?[;&a-z\\d%_.~+=-]*)?' +
			'(\\#[-a-z\\d_]*)?$', 'i');
		return !!pattern.test(str);
	}

	keyDownFunction(event: any) {
		if (event.keyCode === 13) {
			this.sendMsg('', this.msg);
		}
	}
}
